<template>
  <a-spin :spinning="!this.chartData">
    <h2 style="text-align:center">Childbearing Age</h2>
    <svg id="birth-bear-chart"></svg>
  </a-spin>
</template>

<script>
import * as d3 from "d3";
import axios from "axios";
export default {
  name: "BirthBearChart",
  data: function () {
    return {
      chartData: null,
    };
  },
  methods: {
    makeBBChart() {
      var margin = { top: 10, right: 30, bottom: 30, left: 40 },
        width = 500 - margin.left - margin.right,
        height = 380 - margin.top - margin.bottom;
      var parseTime = d3.timeParse("%Y");

      var x = d3.scaleTime().range([0, width]);
      var y = d3.scaleLinear().range([height, 0]);

      // add China's line
      // var china = d3
      //   .line()
      //   .x(function (d) {
      //     return x(d.Year);
      //   })
      //   .y(function (d) {
      //     return y(d.China);
      //   });

      // add Japan's line
      // var japan = d3
      //   .line()
      //   .x(function (d) {
      //     return x(d.Year);
      //   })
      //   .y(function (d) {
      //     return y(d.Japan);
      //   });

      const color = this.$store.state.Color;
      const countries = this.$store.state.Countries;
      var lineArr = []

      for(let country of countries){
        // console.log('this.makeLine(x,y,country) is ',this.makeLine(x,y,country))
        lineArr.push(this.makeLine(x,y,country))
      }


      // console.log("data is ", res);
      const resData = JSON.parse(JSON.stringify(this.chartData));
      for (var item of resData) {
        item.Year = parseTime(item.Year);
        // console.log('item year is ',item.Year)
      }
      // console.log("new data is ", resData);
      var svg = d3
        .select("#birth-bear-chart")
        .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
        // .attr("width", width + margin.left + margin.right)
        // .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");


      // add y axis label
          svg.append("text")
    .style("text-anchor", "end")
        .style("font-size", "13")
        .style("opacity","0.7")
        .attr("x",margin.left -40)
        .attr("y",-25)
        .attr("transform", "rotate(-90)")
        // .style("font-weight","700")
        .text("Female mean age of childbearing (years)")

        // add x axis label
                svg.append("text")
    .style("text-anchor", "end")
        .style("font-size", "13")
        .style("opacity","0.7")
        .attr("x",margin.left + width - 20)
        .attr("y",margin.top + height - 15)
        // .attr("transform", "rotate(-90)")
        // .style("font-weight","700")
        .text("Years")

      x.domain(
        d3.extent(resData, function (d) {
          return d.Year;
        })
      ).nice();

      y.domain([
        0,
        d3.max(resData, function (d) {
          return Math.max(d.China, d.Japan);
        }),
      ]).nice();
      // svg
      //   .append("path")
      //   .data([resData])
      //   .attr("class", "birth-ratio-chart-line")
      //   .attr("name", "china")
      //   .attr("d", china);

      // svg
      //   .append("path")
      //   .data([resData])
      //   .attr("class", "birth-ratio-chart-line")
      //   .attr("name", "japan")
      //   .style("stroke", "red")
      //   .attr("d", japan);

      for(let index in lineArr){
        svg
        .append("path")
        .data([resData])
        .attr("class", "birth-ratio-chart-line")
        .style("stroke", color[index])
        .attr("name", countries[index])
        .attr("d", lineArr[index]);
      }

      svg
        .append("g")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(x));

      // Add the Y Axis
      svg.append("g").call(d3.axisLeft(y));
    },
    makeLine(x,y,country){
      return d3
        .line()
        .x(function (d) {
          return x(d.Year);
        })
        .y(function (d) {
          return y(d[country]);
        })
    }
  },
  mounted: function () {
    // console.log('current url is ',this.$route)
    // console.log('process.env.NODE_ENV is ',process.env.NODE_ENV)
    
    const API = this.$store.state.API;
    if (!this.$store.state.birthBearData) {
      axios
        .get(`${API}birthBear.json`)
        .then((result) => {
          // console.log('resule is ',result.data)
          this.chartData = result.data;
          this.$store.commit("birthBearData", result.data);
          this.makeBBChart();
        })
        .catch((e) => {
          console.error("Error: ", e);
        });
    } else {
      this.chartData = this.$store.state.birthBearData;
      // console.log("vuex chartData is ", this.chartData);
      this.makeBBChart();
    }
  },
};
</script>

<style scoped>
.birth-ratio-chart-line {
  fill: none;
  stroke: steelblue;
  stroke-width: 2px;
}
</style>